__turbopack_context__.v({
  "authorDetails": "Author-module__r6Xy8G__authorDetails",
  "authorSection": "Author-module__r6Xy8G__authorSection",
  "bio-image": "Author-module__r6Xy8G__bio-image",
  "section": "Author-module__r6Xy8G__section",
  "sectionNoMargin": "Author-module__r6Xy8G__sectionNoMargin",
});
